import React from "react";
import Particles from "react-particles-js";
import ParticleConfig from "./Particle.config";

const ParticleBg = () => {
  return <Particles params={ParticleConfig} />;
};

export default ParticleBg;
